import { getCampaigns } from '@/api/requests';
import router from '../../router';
import Vue from 'vue';

const state = {
  campaigns: [],
  adverts: [],
  selectedCampaign: {},
  selectedAdverts: [],
  selectedAdvert: null,
  editCampaign: {},
  createCampaign: false,
};

const mutations = {
  updateAttribute(state, payload) {
    state[payload.type] = payload.value;
  },

  setCampaigns(state, campaigns) {
    state.selectedCampaign = { };
    state.selectedAdvert = null;
    state.campaigns = campaigns;
  },

  setSelectedCampaign(state, campaign) {
    state.selectedCampaign = campaign;
    state.selectedAdvert = null;
    if (campaign.adverts) {
      state.adverts = campaign.adverts;
    } else {
      state.adverts = [];
    }
  },

  setSelectedAdvert(state, advert) {
    state.selectedAdvert = advert;
  },

  updateAdvert(state, advert) {
    if (advert?.title) state.selectedAdvert.title = advert.title;
    if (advert?.description) state.selectedAdvert.description = advert.description;
    if (advert?.destination) state.selectedAdvert.destination = advert.destination;
    if (advert?.destination_value) state.selectedAdvert.destination_value = advert.destination_value;
    if (advert?.button_text) state.selectedAdvert.button_text = advert.button_text;
    if (advert?.active !== null) state.selectedAdvert.active = advert.active;
    if (advert?.image) state.selectedAdvert.image = advert.image;

    let storedAdvert = state.adverts.find(ad => ad.id === advert.id);
    let index = state.adverts.indexOf(storedAdvert);
    state.adverts[index] = state.selectedAdvert;

    Vue.set(state.selectedCampaign, 'adverts', state.adverts);
  },

  addAdvert(state, advert) {
    if (state.selectedCampaign.adverts) {
      Vue.set(state.selectedCampaign.adverts, state.selectedCampaign.adverts.length, advert);
    } else {
      state.selectedCampaign.adverts = [];
      Vue.set(state.selectedCampaign.adverts, state.selectedCampaign.adverts.length, advert);
    }
    state.selectedAdvert = advert;
    state.adverts = state.selectedCampaign.adverts;
  },

  updateCampaign(state, campaign) {
    if (campaign?.title) state.editCampaign.title = campaign.title;

    let storedCampaign = state.campaigns.find(camp => camp.id === campaign.id);
    let index = state.campaigns.indexOf(storedCampaign);
    Vue.set(state.campaigns, index, state.editCampaign);
  },

  addCampaign(state, campaign) {
    if (state.campaigns) {
      Vue.set(state.campaigns, state.campaigns.length, campaign);
    } else {
      state.campaigns = [];
      Vue.set(state.campaigns, state.campaigns.length, campaign);
    }
    state.selectedCampaign = campaign;
  },

  removeAdvert(state, id) {
    let advert = state.adverts.find(advert => advert.id === id);
    let index = state.adverts.indexOf(advert);
    state.adverts.splice(index, 1);

    Vue.set(state.selectedCampaign, 'adverts', state.adverts);
  },

  setEditCampaign(state, campaign) {
    state.editCampaign = campaign;
    state.createCampaign = true;
  },

  closeModal(state) {
    state.editCampaign = {};
    state.createCampaign = false;
  }
};

const actions = {
  loadCampaigns(context, params) {
    getCampaigns(params).then((response) => {
      context.commit('setCampaigns', response.data);
    });
  },

  campaignClicked(context, campaign) {
    context.commit('setSelectedCampaign', campaign);
  },

  advertClicked(context, advert) {
    context.commit('setSelectedAdvert', advert);
  },

  newAdvertClicked(context) {
    context.commit('setSelectedAdvert', {});
  },

  closeAdvertDetails(context) {
    context.commit('setSelectedAdvert', null);
  },

  editCampaignClicked(context, campaign) {
    context.commit('setEditCampaign', campaign);
  },

  closeCampaignPrompt(context) {
    context.commit('closeModal');
  },

};

const getters = {

};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};